import { validationMixin } from 'vuelidate'
import { entitiesLimits } from '@/modules/limits'
import { maxLength, required } from 'vuelidate/lib/validators'
import { containsSpecialCharacters } from '@/utils/validations'

export const MlChildValidationMixin = {
  mixin: [validationMixin],

  computed: {
    entityErrors () {
      const errors = {}
      const { localName } = this.$v

      if (localName && localName.$dirty) {
        if (!localName.required) {
          errors.name = this.$t('validations.ml-child-validation.name.required')
        } else if (!localName.unique) {
          errors.name = this.$t('validations.ml-child-validation.name.unique')
        } else if (!localName.specialCharacters) {
          errors.name = this.$t('validations.ml-child-validation.name.specialCharacters', { specialCharacters: '*\\:<>%{}$&' })
        } else if (!localName.maxLength) {
          errors.name = this.$t('validations.ml-child-validation.name.maxLength', { maxLength: entitiesLimits.simple.name.max })
        }
      }

      return errors
    }
  },

  validations () {
    return {
      // Don't use "this" here, as it's reused in "entity-validation.mixin"
      localName: {
        required,
        maxLength: maxLength(entitiesLimits.list.name.max),
        specialCharacters: value => !containsSpecialCharacters(value),
        unique: (value, { takenNames }) => {
          return !takenNames.some(name => name === value.trim())
        }
      }
    }
  }
}
